import { createEventBus } from "@core/features/eventBus";
import { Invitation } from "@core/features/invitation";

export type MarketingEvents = {
  "addInstitution:submit": { email: string; organization: string };
  "addInstitution:success": { email: string; organization: string };
  "hireUs:submit": { email: string; organization: string };
  "hireUs:success": { email: string; organization: string };
  "newsletter:submitted": { email: string; organizations: string };
  "newsletter:subscribed": { email: string; organizations: string };
  "marketing:invitation:direct:viewed": { invitation: Invitation };
  "marketing:invitation:direct:started": { invitation: Invitation };
};

export const marketingEventBus = createEventBus<MarketingEvents>();

